// Simple pub/sub to relay point updates from axios to Redux without circular imports
const subscribers = new Set();

export function subscribePoints(listener) {
  subscribers.add(listener);
  return () => subscribers.delete(listener);
}

export function publishPoints(points) {
  subscribers.forEach((fn) => {
    try { fn(points); } catch {}
  });
}